import { useSelector, useDispatch } from "react-redux"
import { toggleDarkMode, setDarkMode } from "../redux/actions/themeActions"

export const useDarkMode = () => {
  const isDarkMode = useSelector((state) => state.theme.isDarkMode)
  const dispatch = useDispatch()

  const toggle = () => {
    dispatch(toggleDarkMode())
  }

  const set = (value) => {
    dispatch(setDarkMode(value))
  }

  return {
    isDarkMode,
    toggle,
    set,
  }
}

export default useDarkMode
